import { ofType } from 'redux-observable';
import { forkJoin, of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { switchMap, map } from 'rxjs/operators';

import { objectMap } from '../util/objectMap';
import { LOAD_SOUND_KIT, addSoundKit } from './actions';
import { synthTypes } from './constants';
import { createSourcesMap } from '../util/createSourcesMap';
import { assetsUrl } from '../util/constants';
import { getLoadErrorFromChildren } from '../util/getLoadErrorFromChildren';
import { loadAudioBuffer } from '../util/loadAudioBuffer';

const loadSampler = (sound) =>
   loadAudioBuffer(sound.presetData.sourceFilePath).pipe(
      map((buffer) => ({
         ...sound,
         loadError: buffer == null,
         presetData: { ...sound.presetData, buffer },
      }))
   );

const loadMultiSampler = (sound) =>
   forkJoin(
      sound.presetData.sources.map((source) =>
         loadAudioBuffer(source.sourceFilePath)
      )
   ).pipe(
      map((buffers) =>
         buffers.map((buffer, i) => ({
            ...sound.presetData.sources[i],
            buffer,
            loadError: buffer == null,
         }))
      ),
      map((sources) => ({
         ...sound,
         loadError: getLoadErrorFromChildren(sources),
         presetData: {
            ...sound.presetData,
            sources,
            sourcesMap: createSourcesMap(sources, [-57, 74]),
         },
      }))
   );

export const loadSoundKitEpic = (action$) =>
   action$.pipe(
      ofType(LOAD_SOUND_KIT),
      switchMap((action) => {
         if (action.soundKit) {
            return of(action);
         }
         return ajax({
            url: `${assetsUrl}/public/soundkit/${action.soundKitId}/soundkitDocument.json`,
            crossDomain: true,
         }).pipe(switchMap(({ response }) => of({ soundKit: response })));
      }),
      // resolve presets
      switchMap((action) =>
         forkJoin(
            objectMap(action.soundKit.sounds, (sound) => {
               if (sound.presetId) {
                  return ajax({
                     url: `${assetsUrl}/public/preset/${sound.presetId}/presetDocument.json`,
                     crossDomain: true,
                  }).pipe(
                     switchMap(({ response }) =>
                        of({ ...response, pregain: sound.pregain })
                     )
                  );
               }
               return of(sound);
            })
         ).pipe(
            switchMap((sounds) =>
               of({
                  soundKit: {
                     ...action.soundKit,
                     sounds,
                  },
               })
            )
         )
      ),
      // load audio files
      switchMap((action) =>
         forkJoin(
            objectMap(action.soundKit.sounds, (sound) => {
               switch (sound.type) {
                  case synthTypes.sampler:
                     return loadSampler(sound);
                  case synthTypes.multisampler:
                     return loadMultiSampler(sound);
                  default:
                     return of(sound);
               }
            })
         ).pipe(
            map((sounds) =>
               addSoundKit({
                  ...action.soundKit,
                  loadError: getLoadErrorFromChildren(sounds),

                  sounds,
               })
            )
         )
      )
   );
